import "./SelectYourMission.module.css";
import CommandCenterHeader from "@/reusable_sections/Header";
import FullSpectrumSolutions from "./sections/FullSpectrumSolutions";
import TheDeploymentProcess from "./sections/TheDeploymentProcess";
import StartYourTransformation from "./sections/StartYourTransformation";
import BaseOperationsFooter from "@/reusable_sections/Footer";
export default function SelectYourMissionPage() {
  return <div>
      <CommandCenterHeader />
      <FullSpectrumSolutions />
      <TheDeploymentProcess />
      <StartYourTransformation />
      <BaseOperationsFooter />
    </div>;
}